import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const KioskAuthContext = createContext(null);

export const KioskAuthProvider = ({ children }) => {
  const [kioskUser, setKioskUser] = useState(null);
  const [kioskLoading, setKioskLoading] = useState(true);

  useEffect(() => {
    axios
      .get("/api/kiosk/auth/me", { withCredentials: true })
      .then((res) => {
        if (res.data && res.data.success) {
          setKioskUser(res.data.user || null);
        } else {
          setKioskUser(null);
        }
      })
      .catch(() => {
        setKioskUser(null);
      })
      .finally(() => {
        setKioskLoading(false);
      });
  }, []);

  const kioskLogin = (userData) => {
    setKioskUser(userData);
  };

  const kioskLogout = () => {
    setKioskUser(null);
  };

  return (
    <KioskAuthContext.Provider
      value={{
        kioskUser,
        setKioskUser,
        kioskLogin,
        kioskLogout,
        kioskLoading,
      }}
    >
      {children}
    </KioskAuthContext.Provider>
  );
};

export const useKioskAuth = () => {
  const context = useContext(KioskAuthContext);

  if (!context) {
    throw new Error("useKioskAuth must be used within a KioskAuthProvider");
  }

  return context;
};